import { render, staticRenderFns } from "./paymentcancel.vue?vue&type=template&id=65b2983c&scoped=true"
import script from "./paymentcancel.vue?vue&type=script&lang=js"
export * from "./paymentcancel.vue?vue&type=script&lang=js"
import style0 from "./paymentcancel.vue?vue&type=style&index=0&id=65b2983c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b2983c",
  null
  
)

export default component.exports